// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

export async function auth(body: API.authReq, options?: { [key: string]: any }) {
  return request<API.authRes>('/api/v1/auth', {
    baseURL: API_BASE_URL,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function getUser(options?: { [key: string]: any }) {
  return request<API.userRes>('/api/v1/auth/me', {
    baseURL: API_BASE_URL,
    method: 'GET',
    ...(options || {}),
  });
}

export async function logout(body: API.logoutReq, options?: { [key: string]: any }) {
  return request<API.logoutRes>('/api/v1/logout', {
    baseURL: API_BASE_URL,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function getPartners(options?: { [key: string]: any }) {
  return request<API.PartnersRes>('/api/v1/partners', {
    baseURL: API_BASE_URL,
    method: 'GET',
    ...(options || {}),
  });
}

export async function getCurrencies(options?: { [key: string]: any }) {
  return request<API.CurrenciesRes>('/api/v1/currencies', {
    baseURL: API_BASE_URL,
    method: 'GET',
    ...(options || {}),
  }).then((res) => res.currencies);
}

export async function getOperators(options?: { [key: string]: any }) {
  return request<API.OperatorsRes>('/api/v1/operators/', {
    baseURL: API_BASE_URL,
    method: 'GET',
    ...(options || {}),
  });
}

export async function getUserPermissions(options?: { [key: string]: any }) {
  return request<API.UserPermissionsRes>('/api/v1/auth/permissions', {
    baseURL: API_BASE_URL,
    method: 'GET',
    ...(options || {}),
  });
}

export async function getGames(options?: { [key: string]: any }) {
  return request<API.GamesRes>('/api/v1/games/', {
    baseURL: API_BASE_URL,
    method: 'GET',
    ...(options || {}),
  });
}

export async function getLiveChart(
  body: API.LivePlayersChartReq,
  options?: { [key: string]: any },
) {
  return request<API.LivePlayersChartRes>('/api/v1/live', {
    baseURL: API_BASE_URL,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function getTopPlayers(body: API.TopPlayersReq, options?: { [key: string]: any }) {
  return request<API.TopPlayersRes>('/api/v1/players/top', {
    baseURL: API_BASE_URL,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function getSummaryStats(body: API.SummaryStatsReq, options?: { [key: string]: any }) {
  return request<API.SummaryStatsRes>('/api/v1/stats/summary', {
    baseURL: API_BASE_URL,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function getStats(body: API.StatsReq, options?: { [key: string]: any }) {
  return request<API.StatsRes>('/api/v1/stats', {
    baseURL: API_BASE_URL,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function getPlayers(
  userId: string | '',
  body: API.PlayersReq,
  options?: { [key: string]: any },
) {
  return request<API.PlayersRes>(`/api/v1/players/stats/${encodeURIComponent(userId)}`, {
    baseURL: API_BASE_URL,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function getRounds(body: API.TransactionsReq, options?: { [key: string]: any }) {
  return request<API.RoundsRes>('/api/v1/transactions', {
    baseURL: API_BASE_URL,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function getGameEvents(betId: string, options?: { [key: string]: any }) {
  return request<API.GameEventRes>(`/api/v1/transactions/${encodeURIComponent(betId)}/events`, {
    baseURL: API_BASE_URL,
    method: 'POST',
    ...(options || {}),
  });
}

export async function getPromos(
  params?: {
    partnerName?: string;
    excludeDeleted?: boolean;
    limit?: number;
    offset?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.PromosRes>('/api/v1/promo-campaigns', {
    baseURL: API_BASE_URL,
    method: 'GET',
    params: {
      partnerName: params?.partnerName,
      excludeDeleted: params?.excludeDeleted,
      limit: params?.limit,
      offset: params?.offset,
    },
    ...(options || {}),
  });
}

export async function getPromoCampaign(id: string, options?: { [key: string]: any }) {
  return request<API.PromoCampaign>(`/api/v1/promo-campaigns/${id}`, {
    baseURL: API_BASE_URL,
    method: 'GET',
    ...(options || {}),
  });
}

export async function createPromoCampaign(
  body: API.CreatePromoCampaignReq,
  options?: { [key: string]: any },
) {
  return request<API.PromoCampaign>('/api/v1/promo-campaigns', {
    baseURL: API_BASE_URL,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function deletePromoCampaign(id: string, options?: { [key: string]: any }) {
  return request<{ deleted: boolean }>(`/api/v1/promo-campaigns/${id}`, {
    baseURL: API_BASE_URL,
    method: 'DELETE',
    ...(options || {}),
  });
}

export async function getLivePlayersByGroup(
  body: API.LivePlayersByGroupReq,
  options?: { [key: string]: any },
) {
  return request<API.LivePlayerGroup[]>('/api/v1/live/groups', {
    baseURL: API_BASE_URL,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function createOperator(
  body: API.CreateOperatorReq,
  options?: { [key: string]: any },
) {
  return request<API.CreateOperatorRes>('/api/v1/operators', {
    baseURL: API_BASE_URL,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function getBettingSettings(
  params: API.GetBettingSettingsReq,
  options?: { [key: string]: any },
) {
  return request<API.BettingSettingsList>('/api/v1/betting-settings', {
    baseURL: API_BASE_URL,
    method: 'GET',
    params: params,
    ...(options || {}),
  });
}

export async function deleteBettingSetting(
  params: API.DeleteBettingSettingReq,
  options?: { [key: string]: any },
) {
  return request(`/api/v1/betting-settings`, {
    baseURL: API_BASE_URL,
    method: 'DELETE',
    params: params,
    ...(options || {}),
  });
}

export async function getBettingSettingsKeys(options?: { [key: string]: any }) {
  return request<API.GetBettingSettingsKeysRes>('/api/v1/betting-settings/keys', {
    baseURL: API_BASE_URL,
    method: 'GET',
    ...(options || {}),
  });
}

export async function upsertBettingSetting(
  body: API.UpsertBettingSettingReq,
  options?: { [key: string]: any },
) {
  return request(`/api/v1/betting-settings`, {
    baseURL: API_BASE_URL,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
